import React from "react";
import { motion } from "framer-motion";
import { Band, Glow, Eyebrow, Reveal, PrimaryCTA } from "./shared";

export function ApproachSection() {
  return (
    <Band id="approach">
      <Glow className="top-0 right-1/4 w-[460px] h-[460px] bg-[#22D3EE]/8" />
      <Reveal>
        <div className="text-center max-w-3xl mx-auto">
          <Eyebrow className="text-[#22D3EE]">A New Way Out</Eyebrow>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight text-white mt-3 leading-[1.05]">
            An innovative approach to solving back pain
          </h2>
          <p className="text-lg text-[#C7D6EA] mt-6 leading-relaxed">
            Heal the <span className="text-[#38BDF8] font-semibold">emotional</span>, <span className="text-[#22D3EE] font-semibold">mental</span> and <span className="text-[#F59E0B] font-semibold">physical</span> patterns that keep you in a pain loop, always bracing for the next flare-up or spasm.
          </p>
          <p className="text-base text-[#B8C7DC] mt-5 leading-relaxed">
            <span className="text-white font-semibold">Freedom From Back Pain</span> is your 4-week journey that demystifies your chronic pain, designed to uncover the repressed emotions stealing your best life from you, day after day. Restore your confidence, expand your capabilities daily, and live fully for yourself and the people you care about. The program goes deep into unravelling who you are, and everything you could accomplish without your back pain.
          </p>
        </div>
      </Reveal>
      <Reveal delay={0.1}>
        <div className="mt-10 flex flex-wrap justify-center gap-4">
          {[["Emotional", "#38BDF8"], ["Mental", "#22D3EE"], ["Physical", "#F59E0B"]].map(([t, c], i) => (
            <motion.span
              key={t}
              className="relative inline-flex items-center gap-2.5 rounded-full border px-6 py-3 text-sm font-semibold tracking-wide overflow-hidden"
              style={{ borderColor: `${c}88`, color: c, background: `${c}14` }}
              initial={{ boxShadow: `0 0 0px ${c}00` }}
              animate={{ boxShadow: [`0 0 12px ${c}33`, `0 0 28px ${c}88`, `0 0 12px ${c}33`] }}
              transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut", delay: i * 0.4 }}
              whileHover={{ scale: 1.06 }}
            >
              <motion.span
                className="w-2.5 h-2.5 rounded-full"
                style={{ background: c }}
                animate={{ boxShadow: [`0 0 6px ${c}`, `0 0 16px ${c}`, `0 0 6px ${c}`], scale: [1, 1.25, 1] }}
                transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut", delay: i * 0.4 }}
              />
              {t}
            </motion.span>
          ))}
        </div>
        <div className="mt-9 flex justify-center"><PrimaryCTA testid="approach-cta" /></div>
      </Reveal>
    </Band>
  );
}
